import { registerSW } from "virtual:pwa-register";

let applyUpdate: ((reloadPage?: boolean) => Promise<void>) | null = null;
let updateReady = false;
let updateTimer: number | null = null;
let registeredServiceWorker: ServiceWorkerRegistration | null = null;
const updateReadyListeners = new Set<(ready: boolean) => void>();

function setUpdateReady(next: boolean) {
  updateReady = next;
  for (const listener of updateReadyListeners) listener(next);
}

function requestBackgroundUpdate() {
  if (!registeredServiceWorker || !navigator.onLine) return;
  void registeredServiceWorker.update().catch(() => undefined);
}

export function registerPosServiceWorker() {
  applyUpdate = registerSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      registeredServiceWorker = registration ?? null;
      requestBackgroundUpdate();

      if (updateTimer !== null) window.clearInterval(updateTimer);
      updateTimer = window.setInterval(requestBackgroundUpdate, 5 * 60 * 1000);
    },
    onNeedRefresh() {
      setUpdateReady(true);
      window.dispatchEvent(new CustomEvent("more-pos:update-ready"));
    },
    onOfflineReady() {
      window.dispatchEvent(new CustomEvent("more-pos:offline-shell-ready"));
    },
  });

  const checkWhenForegrounded = () => {
    if (document.visibilityState === "visible") requestBackgroundUpdate();
  };
  document.addEventListener("visibilitychange", checkWhenForegrounded);
  window.addEventListener("online", requestBackgroundUpdate);
}

export function isPosUpdateReady() {
  return updateReady;
}

export function subscribePosUpdateReady(listener: (ready: boolean) => void) {
  updateReadyListeners.add(listener);
  listener(updateReady);
  return () => {
    updateReadyListeners.delete(listener);
  };
}

export async function applyPosUpdateAtSafePoint() {
  if (!applyUpdate) return;
  await applyUpdate(true);
  setUpdateReady(false);
}
